import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import { Grid, Typography, TextField, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CustomButton } from '../button';
import GuideMessageM from '../message/GuideMessageM';

// 탈퇴 1단계 — 이메일 회원은 비밀번호가 맞아야 다음 단계로 간다(서버 확인). 소셜 회원은 비밀번호 칸 없이 바로 진행
const useStyles = makeStyles(() => ({
  inputBox: {
    maxWidth: 500,
    padding: '0 30px',
    '& .MuiBox-root': {
      marginBottom: 40,
    },
    margin: '60px 0',
  },
  error: {
    marginTop: 8,
    color: '#f77c40',
  },
}));

function PasswordForm({ handleCheck, loginStore }) {
  const cs = useStyles();
  const { userInfo, verifyPasswordCall } = loginStore;
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const needPassword = Boolean(userInfo && userInfo.userJoinType === 'Email');

  const next = async (e) => {
    if (e) e.preventDefault();
    if (busy) return;
    if (needPassword && !password) { setError('비밀번호를 입력해 주세요.'); return; }
    setBusy(true);
    setError('');
    const r = await verifyPasswordCall(password);
    setBusy(false);
    if (!r.ok) { setError(r.message); return; }
    handleCheck('checked', password);
  };

  return (
    <React.Fragment>
      <Grid item>
        <GuideMessageM
          title="탈퇴하기"
          subTitle="탈퇴 시 이용하셨던 모든 기록이 삭제됩니다</br>회원을 탈퇴 하시겠습니까?"
        />
      </Grid>
      <Grid className={cs.inputBox} container direction="column" justify="center" alignItems="flex-start">
        <form onSubmit={next} style={{ width: '100%' }}>
          {needPassword && (
            <Box className="mainFormGroup">
              <TextField
                type="password"
                placeholder="비밀번호를 입력해주세요."
                variant="outlined"
                fullWidth
                className="formArea"
                value={password}
                autoComplete="current-password"
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                error={Boolean(error)}
              />
              {error && <Typography variant="body2" className={cs.error} align="left">{error}</Typography>}
            </Box>
          )}
          {!needPassword && error && <Typography variant="body2" className={cs.error} align="left" gutterBottom>{error}</Typography>}
          <CustomButton type="submit" fullWidth variant="contained" color="primary" disabled={busy}>
            {busy ? '확인 중' : '탈퇴하기'}
          </CustomButton>
        </form>
      </Grid>
    </React.Fragment>
  );
}

export default inject('loginStore')(observer(PasswordForm));
